export const AGENT_INTEGRATION_ID: string =
  import.meta.env.VITE_AGENT_INTEGRATION_ID ?? '';

export const AGENT_PROJECT_ID: string =
  import.meta.env.VITE_AGENT_PROJECT_ID ?? '';

export const AGENT_MODEL = 'kapa-agent-1.0';

export const AGENT_API_BASE_URL: string | undefined =
  import.meta.env.VITE_AGENT_API_BASE_URL || undefined;
